import { renderToString } from "katex";

const decodeEntities = (value?: string) => {
  const element = document.createElement("div");
  element.innerHTML = value?.trim() ?? "";
  const text = element.innerText;

  return text;
};

const removeNbspOutsideText = (tex: string) => {
  return tex.replace(/\\text\{[^}]*\}|&nbsp;/g, (match) => {
    if (match.startsWith("\\text{")) {
      return match;
    }
    return "";
  });
};

const FORMULA_REGEX = /\$([\s\S]*?)\$/g;

export const processValue = async (value?: string) => {
  if (!value) return "";

  try {
    return Promise.resolve(
      value.replace(FORMULA_REGEX, (_, content) => {
        const cleaned = removeNbspOutsideText(content.trim());
        const formula = decodeEntities(cleaned);

        const result = renderToString(formula, {
          throwOnError: false,
          displayMode: false,
        }).replace(/(>)([^<]*?)(\d+)\.(\d+)([^<]*?)(<)/g, "$1$2$3٫$4$5$6");

        return result;
      }),
    );
  } catch (error) {
    console.error("Worker failed to process KaTeX:", error);

    return value;
  }
};
